import create from './create';
import get from './get';
import resend from './resend';
import update from './update';
import remove from './remove';

export default [create, get, resend, update, remove];
